import { createApiRef } from '@backstage/core-plugin-api';

/**
 * Announcement Category
 */
export type Category = {
  slug: string;
  title: string;
};

/**
 * Announcement
 */
export type Announcement = {
  id: string;
  category?: Category;
  publisher: string;
  title: string;
  excerpt: string;
  body: string;
  created_at: string;
};

/**
 * Announcements List
 */
export type AnnouncementsList = {
  count: number;
  results: Announcement[];
};

/**
 * Announcements API
 */
export interface AnnouncementsApi {
  announcements(opts: {
    max?: number;
    page?: number;
    category?: string;
  }): Promise<AnnouncementsList>;
  announcementByID(id: string): Promise<Announcement>;
  lastSeenDate(): Date;
}

/**
 * Announcements API Ref
 */
export const announcementsApiRef = createApiRef<AnnouncementsApi>({
  id: 'plugin.announcements.service',
});
